import React, { useEffect, useState } from 'react';

import MetaTags from 'react-meta-tags';
import Box from "@material-ui/core/Box";
import GeneralStyles from '../../styles/GeneralStyles';
import axios from 'axios';
import clsx from "clsx";
import { useCookies } from 'react-cookie';
import cookieName from '../../helpers/cookiesDeclaration';
import CircularProgress from '@material-ui/core/CircularProgress';

const useGeneralStyles = GeneralStyles;


function News(props) {
    const classesG = useGeneralStyles();
    const [news, setNews] = useState(null);
    const [firstNews, setFirstNews] = useState(null);
    const [newsPage, setNewsPage] = useState(null);
    const [loading, setLoading] = useState(false);
    const [cookies, setCookie] = useCookies([cookieName]);

    useEffect(() => {
        setLoading(true);
        axios
            .get(
                `${process.env.REACT_APP_GATEWAY_END_POINT}/news-page`)
            .then((response) => {
                setNewsPage(response.data);
            })
            .catch((error) => {
                setLoading(true);
            });

        axios
            .get(
                `${process.env.REACT_APP_GATEWAY_END_POINT}/news-contents?_sort=Date:DESC`)
            .then((response) => {
                setNews(response.data);
                setFirstNews(response.data[0]);
                // console.log('NEWS: ' + JSON.stringify(response.data[0]));
                setLoading(false);
            })
            .catch((error) => {
                setLoading(true);
            });
    }, []);

    const handleRedirectNews = item => {
        var userD = {};
        userD.urlNews = item;
        setCookie(cookieName, JSON.stringify(userD), { path: '/' });

        const { history, location } = props;
        const { from } = location.state || {
            from: {
                pathname: `/newsContent/${item}`,
            },
        };
        history.push(from);
    };

    const replace = (param) => {
        var value = '';

        if (param !== '' && param !== null && param !== undefined) {
            value = param.replace(`${process.env.REACT_APP_GATEWAY_PATH_REPLACE}`, `${process.env.REACT_APP_GATEWAY_PATH_S3}`);
        }

        return value;
    }

    return (
        <React.Fragment>
            {loading && (
                <div className={classesG.divProgress}>
                <CircularProgress size={68} className={classesG.progress} />
                </div>
            )}
            {!loading && (
                <React.Fragment>
                    {newsPage === null ? '' : (
                        <MetaTags>
                            <title>{newsPage.Page_title}</title>
                            <meta name="description" content={newsPage.Page_description} />
                        </MetaTags>
                    )}
                    <div className={classesG.container}>

                        <section className={classesG.section}>
                            <div className={classesG.newsSectionBackground}></div>
                            {firstNews === null || firstNews === '' || firstNews === undefined ? '' :
                                (
                                    firstNews.Priority_image === true ? (
                                        <div className={classesG.workSecondSectionContent}>
                                            <div className={classesG.workSectionBox}>
                                                <div className={classesG.workfirstSectionText}>
                                                    {newsPage === null ? '' : (
                                                        <h2>{newsPage.Title}</h2>
                                                    )}
                                                    <div>
                                                        <img src={replace(firstNews.Image.url)} alt={firstNews.Title} onClick={() => handleRedirectNews(firstNews.Url)} />
                                                    </div>
                                                    <h4> {firstNews.Title}</h4>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className={classesG.workExamplesSecondSectionContent}>
                                            <div className={classesG.workExampleSectionBox}>
                                                <div className={classesG.newsExampleFirstSectionText} >

                                                    {newsPage === null ? '' : (
                                                        <h2>{newsPage.Title}</h2>
                                                    )}

                                                    <div className={classesG.divVideo} onClick={() => handleRedirectNews(firstNews.Url)}>
                                                        <video src={replace(firstNews.Background_video.url)}
                                                            playsInline autoPlay={'autoplay'} loop={true} muted id='video1'>
                                                        </video>
                                                    </div>
                                                    <h4
                                                        className={classesG.workH4}
                                                        style={{ color: '#ffffff', marginTop: '16px' }}
                                                        onClick={() => handleRedirectNews(firstNews.Url)}
                                                    > {firstNews.Title}</h4>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                )
                            }
                        </section>


                        <section className={classesG.section}>
                            <div className={classesG.newsSecondSectionBackground}></div>
                            <div className={classesG.workSecondSectionContent}>
                                <div className={classesG.sectionBox}>
                                    <div className={classesG.newsSecondSectionImages}>
                                        <ul>
                                            {news === null ? '' : news.map((items, i) => (
                                                <React.Fragment>
                                                    {i === 0 ? '' :
                                                        <React.Fragment>
                                                            {
                                                                items.Priority_image === true ?
                                                                    (
                                                                        <li key={i} onClick={() => handleRedirectNews(items.Url)} >
                                                                            <div>
                                                                                <img src={replace(items.Image.url)} alt={items.Title} />
                                                                            </div>
                                                                            <h4 className={clsx({
                                                                                [classesG.workH4]: i <= 2,
                                                                                [classesG.workH4_Black]: i > 2,
                                                                            })}>
                                                                                {items.Title}
                                                                            </h4>
                                                                        </li>
                                                                    ) :
                                                                    (
                                                                        <li key={i} onClick={() => handleRedirectNews(items.Url)} >
                                                                            <div className={classesG.divVideo} onClick={() => handleRedirectNews(items.Url)}>
                                                                                <video src={replace(items.Background_video.url)}
                                                                                    playsInline autoPlay={'autoplay'} loop={true} muted id='video1'>
                                                                                </video>
                                                                            </div>
                                                                            <h4 className={clsx({
                                                                                [classesG.workH4]: i <= 2,
                                                                                [classesG.workH4_Black]: i > 2,
                                                                            })}>
                                                                                {items.Title}
                                                                            </h4>
                                                                        </li>
                                                                    )
                                                            }
                                                        </React.Fragment>
                                                    }
                                                </React.Fragment>

                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <Box mt={7}></Box>
                    </div>
                </React.Fragment>
            )}
        </React.Fragment>
    );
}

export default (News);